// src/features/Customer/api/customer.ts
import { Customer, CustomerFiltersCustomerStatusEnum } from '@baia-api/baia-api';



import { apiClient } from '@/lib/baia-api-client/baia-service-api-client';





export const customerApi = {
  /**
   * Ruft den aktuellen Kunden ab.
   * Corresponds to: GET /customers/{uuid}
   */
  async getCurrentCustomer(): Promise<Customer> {
    const response = await apiClient.customer.getCurrentCustomer();
    return response.data;
  },

  /**
   * Aktualisiert einen bestehenden Kunden.
   * Corresponds to: PATCH /customers/{uuid}
   */
  async update(id: string, customerData: Partial<Customer>): Promise<Customer> {
    const response = await apiClient.customer.updateCustomer(id, customerData);
    return response.data;
  },

  /**
   * Ruft alle Customer ab, die den Filtern entsprechen
   * Corresponds to: GET /customers/{filters}
   */
  async getFilteredCustomers(
    productCategories: string[],
    customerStatus: CustomerFiltersCustomerStatusEnum,
    region: string,
  ): Promise<{ customers: Customer[]; totalNumber: number }> {
    const response = await apiClient.customer.getCustomersByFilters({
      customerStatus,
      productCategories,
      region,
    });
    return {
      customers: response.data.customers || [],
      totalNumber: response.data.totalNumber || 0,
    };
  },
};
